import React from 'react';
import { Form } from '@rocketseat/unform';
import { ContainerSuccess } from './styles';

export default function ChangeProfileSuccess() {
  return (
    <ContainerSuccess>
      <Form>
        <h2>Minha Conta</h2>
        <div>Dados alterados com sucesso!</div>
      </Form>
    </ContainerSuccess>
  );
}
